import { createSlice } from "@reduxjs/toolkit";

interface ClientStateType {
  id: number;
  clientId: number;
  clientName: string;
  userId: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  jobTitle: string | null;
  photoUrl: string | null;
  isActive: boolean;
  profileError: any;
  clientLoading: boolean;
}

export const initialState: ClientStateType = {
  id: 0,
  clientId: 0,
  clientName: "",
  userId: 0,
  username: "",
  email: "",
  firstName: "",
  lastName: "",
  fullName: "",
  jobTitle: null,
  photoUrl: null,
  isActive: true,
  profileError: null,
  clientLoading: true,
};

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClientProfile(state, action) {
      state.id = action.payload.id;
      state.clientId = action.payload.clientId;
      state.clientName = action.payload.clientName;
      state.userId = action.payload.userId;
      state.username = action.payload.username;
      state.email = action.payload.email;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.fullName = action.payload.fullName;
      state.jobTitle = action.payload.jobTitle;
      state.photoUrl = action.payload.photoUrl;
      state.isActive = action.payload.isActive;
      state.profileError = initialState.profileError;
      state.clientLoading = action.payload.loading;
    },
    setProfileError(state, action) {
      state.profileError = action.payload;
    },
  },
});

export const { setClientProfile, setProfileError } = clientSlice.actions;

export default clientSlice.reducer;
